var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPricing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 0.75C4.25 0.334375 4.58437 0 5 0C5.41563 0 5.75 0.334375 5.75 0.75V2H7.75C8.16563 2 8.5 2.33437 8.5 2.75C8.5 3.16563 8.16563 3.5 7.75 3.5H3.6875C2.75625 3.5 2 4.25625 2 5.1875C2 6.0125 2.59687 6.71562 3.40937 6.85L6.725 7.40312C8.32812 7.66875 9.5 9.05625 9.5 10.6781C9.5 12.5125 8.0125 14 6.17812 14H5.75V15.25C5.75 15.6656 5.41563 16 5 16C4.58437 16 4.25 15.6656 4.25 15.25V14H1.75C1.33438 14 1 13.6656 1 13.25C1 12.8344 1.33438 12.5 1.75 12.5H6.17812C7.18437 12.5 8 11.6844 8 10.6781C8 9.7875 7.35625 9.02813 6.47813 8.88125L3.1625 8.32812C1.625 8.07187 0.5 6.74375 0.5 5.1875C0.5 3.425 1.925 2 3.6875 2H4.25V0.75Z",
    fill: "#B88333",
    stroke: "#B88333",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricing);
export default __webpack_public_path__ + "static/media/pricing.faac0d4bb8b49925ba559d2074237e0d.svg";
export { ForwardRef as ReactComponent };